import React from "react";
import { Link } from "react-router-dom"; // Menggunakan useLocation
import { FaSignOutAlt, FaShoppingBasket } from "react-icons/fa";
import { FaWallet } from "react-icons/fa6";

const Navbar = ({ handleLogout }) => {

    return (
        <div className="navbar bg-base-100 shadow-lg">
            <div className="flex-1">
                <Link to="/admin" className="btn btn-ghost normal-case text-xl">
                    PPOB App
                </Link>
            </div>
            <div className="flex-none">
                <div className="dropdown dropdown-end">
                    <label tabIndex={0} className="btn btn-ghost">
                        <div className="w-10 rounded-full">
                            <img
                                src="https://cdn-icons-png.freepik.com/128/3917/3917618.png"
                                style={{ width: "25px", height: "25px" }}
                                alt="Profile Icon"
                            />
                        </div>
                    </label>
                    <ul
                        tabIndex={0}
                        className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52"
                    >
                        <li>
                            <Link to="/deposit"><FaWallet /> deposit</Link>
                        </li>
                        <li>
                            <Link to="/product"><FaShoppingBasket /> Daftar produk</Link>
                        </li>
                        <li>
                            <button
                                onClick={handleLogout}
                                className="text-red-500"
                            >
                                <FaSignOutAlt className="mr-2" />
                                Log Out
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
